export function hidePartOfDoc(string: string) {
	const primeiraParte = string.substring(3, string.length - 2)
	const asteriscos = '*'.repeat(3)
	return asteriscos + primeiraParte + asteriscos
}
